import { getIsNewSearch } from "../../state/modules/search/selectors";

const shouldFetch = ({ state, isNewPage }) =>
  getIsNewSearch(state) || isNewPage;

export default shouldFetch;
